import * as React from "react";
const SvgFiRrRoute = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-route_svg__a)">
      <path
        fill="#062147"
        d="M5.005 24.006a2.23 2.23 0 0 1-1.524-.596l-1.99-1.849c-1.976-1.975-1.976-5.147-.026-7.096a4.97 4.97 0 0 1 3.536-1.464c1.335 0 2.591.52 3.535 1.464a4.97 4.97 0 0 1 1.465 3.536c0 1.336-.52 2.591-1.465 3.535l-2.001 1.871c-.428.4-.978.6-1.528.6zM5 15c-.801 0-1.555.312-2.122.879a3.004 3.004 0 0 0 0 4.242l1.964 1.824a.24.24 0 0 0 .326 0l1.977-1.847A2.96 2.96 0 0 0 7.999 18a2.98 2.98 0 0 0-.879-2.122A2.98 2.98 0 0 0 5 15m14.005-3.994a2.23 2.23 0 0 1-1.524-.596l-1.99-1.849c-1.976-1.975-1.976-5.147-.026-7.096A4.97 4.97 0 0 1 19.001.001c1.336 0 2.59.52 3.535 1.464a5.005 5.005 0 0 1 0 7.071l-2.001 1.871c-.428.4-.979.6-1.529.6zM19 2c-.802 0-1.555.312-2.122.878a3.005 3.005 0 0 0 0 4.243l1.963 1.824a.24.24 0 0 0 .327 0l1.977-1.847c1.145-1.146 1.145-3.049-.024-4.219A2.98 2.98 0 0 0 19 2m5 18c0-2.206-1.794-4-4-4h-5c-1.103 0-2-.897-2-2 0-.847.536-1.604 1.333-1.886a1 1 0 1 0-.666-1.886A4.01 4.01 0 0 0 11 14c0 2.206 1.794 4 4 4h5c1.103 0 2 .897 2 2s-.897 2-2 2h-9a1 1 0 0 0 0 2h9c2.206 0 4-1.794 4-4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-route_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRoute;
